import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
export const SummaryCard = ({ title, values, path }) => {
  const navigate = useNavigate();
  const formatAmount = (amount) =>
    Number(amount).toLocaleString("en-IN", { maximumFractionDigits: 2 });
  const formatPercent = (percent) => `${Number(percent).toFixed(2)}%`;

  return (
    <div className="border p-3 rounded-3 shadow-sm h-100 bg-body shine-effect w-100">
      <div className="row g-3">
        <div className="col-md-12">
          <div className="d-flex align-items-center gap-3">
            <p className="fw-bold mb-0">{title}</p>
            <FontAwesomeIcon
              onClick={() => navigate(path)}
              icon={faArrowRight}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>

        {title !== "🚀 My Multibaggers" && (
          <>
            <div className="col-6">
              <small className="text-muted">Investment Amount</small>
              <h6 className="mb-0">{formatAmount(values.investment)}</h6>
            </div>
            <div className="col-6">
              <small className="text-muted">Available Funds</small>
              <h6 className="mb-0">{formatAmount(values.fund)}</h6>
            </div>
          </>
        )}

        <div className="col-6">
          <small className="text-muted">Invested</small>
          <h6 className="mb-0">{formatAmount(values.invested)}</h6>
        </div>
        <div className="col-6">
          <small className="text-muted">Current Value</small>
          <h6 className="mb-0">{formatAmount(values.current)}</h6>
        </div>
        <div className="col-6">
          <small className="text-muted">Overall P&L</small>
          <div className="d-flex align-items-baseline">
            <h6
              className={`mb-0 ${
                values.overallPL.value < 0 ? "text-red" : "text-green"
              }`}
            >
              {formatAmount(values.overallPL.value)}
            </h6>
            <small
              className={`ms-2 ${
                values.overallPL.percent < 0 ? "text-red" : "text-green"
              }`}
            >
              {formatPercent(values.overallPL.percent)}
            </small>
            {/* <small className="text-green ms-2">{formatPercent(values.overallPL.percent)}</small> */}
          </div>
        </div>
        <div className="col-6">
          <small className="text-muted">Day's P&L</small>
          <div className="d-flex align-items-baseline">
            <h6
              className={`mb-0 ${
                values.dayPL.value < 0 ? "text-red" : "text-green"
              }`}
            >
              {formatAmount(values.dayPL.value)}
            </h6>
            <small
              className={`ms-2 ${
                values.dayPL.percent < 0 ? "text-red" : "text-green"
              }`}
            >
              {formatPercent(values.dayPL.percent)}
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};
